/**
 * SiteFooter.tsx — Reutilizabil pe toate paginile
 *
 * Design: dark background (stone-900), logo, linkuri rapide, copyright
 */

import { Link } from "wouter";
import { MapPin, Mail, ArrowRight } from "lucide-react";

const YEAR = new Date().getFullYear();

export default function SiteFooter() {
  return (
    <footer style={{ backgroundColor: "oklch(0.14 0.008 60)", fontFamily: "'Source Sans 3', sans-serif" }}>
      <div className="container max-w-5xl py-16 px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 pb-12 border-b border-white/10">

          {/* Brand */}
          <div className="md:col-span-2">
            <Link href="/" className="no-underline flex items-center gap-2 mb-4">
              <div className="bg-white rounded p-1 flex items-center justify-center" style={{ width: '48px', height: '48px' }}>
                <img
                  src="https://files.manuscdn.com/user_upload_by_module/session_file/310419663030265086/VVZZLAPpvULlxcVm.webp"
                  alt="Brașov Gateway"
                  width={40}
                  height={40}
                  className="h-10 w-auto object-contain"
                />
              </div>
              <span className="text-white font-semibold text-sm uppercase tracking-widest" style={{ fontFamily: "'Playfair Display', serif", letterSpacing: "0.12em" }}>
                Brașov Gateway
              </span>
            </Link>
            <p className="text-stone-300 text-sm leading-relaxed max-w-xs mb-6">
              Real estate, business setup, and relocation support — for those who want to do it right the first time.
            </p>
            <div className="flex items-center gap-2 text-stone-300 text-xs mb-2">
              <MapPin size={12} />
              <span>Brașov, Romania</span>
            </div>
            <div className="flex items-center gap-2 text-stone-300 text-xs">
              <Mail size={12} />
              <a href="mailto:hello@brasovgateway.com" className="hover:text-stone-300 transition-colors no-underline">hello@brasovgateway.com</a>
            </div>
          </div>

          {/* Services */}
          <div>
            <p className="text-xs uppercase tracking-[0.15em] text-stone-300 mb-4">Services</p>
            <ul className="space-y-3">
              {[
                { label: "Real Estate", href: "/services/real-estate" },
                { label: "Company Setup", href: "/services/company-setup" },
                { label: "Relocation Support", href: "/contact" },
                { label: "Business Opportunities", href: "/contact" },
              ].map((item) => (
                <li key={item.label}>
                  <Link href={item.href} className="text-stone-400 hover:text-white text-sm no-underline transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick links */}
          <div>
            <p className="text-xs uppercase tracking-[0.15em] text-stone-300 mb-4">Quick links</p>
            <ul className="space-y-3">
              {[
                { label: "Why Brașov", href: "/#why" },
                { label: "About", href: "/about" },
                { label: "Blog", href: "/blog" },
                { label: "Contact", href: "/contact" },
              ].map((item) => (
                <li key={item.label}>
                  <Link href={item.href} className="text-stone-400 hover:text-white text-sm no-underline transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>

            <div className="mt-8">
              <Link
                href="/contact"
                className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-white no-underline hover:opacity-80 transition-opacity px-4 py-2"
                style={{ backgroundColor: "oklch(0.38 0.12 15)" }}
              >
                Get in touch <ArrowRight size={12} />
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-stone-400 text-xs">
            © {YEAR} Brașov Gateway. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link href="/privacy-policy" className="text-stone-400 hover:text-stone-200 text-xs no-underline transition-colors">
              Privacy Policy
            </Link>
            <span className="text-stone-400 text-xs">Brașov, Romania · EU</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
